// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1nZod","colMin":"styles_colMin__2imr4","colCheckbox":"styles_colCheckbox__2m_hY"};